import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import LogFingerSapTableEmployee from "../components/LogFingerSapTableEmployee";

import Delete from "./RemoveSapFE";
import axios from "axios";

export default function Employers(props) {

  const {
    chooseSapId,
    setChooseSapId,
    setShowLog,
    showLog,
  } = props;

  const [logRows, setLogRows] = useState([]);
  const [isError, setIsError] = useState(false);
  const [sortField, setSortField] = useState("");
  const [orderBy, setOrderBy] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(1000);
  const [logId, setLogId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [showRemove, setShowRemove] = useState(false);

  const onLogRows = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}employee/${chooseSapId}`,

      )
      .then(({ data }) => {
        setIsLoading(false);
        setLogRows(data.employeeFingerDataList);
        setIsError(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
        setLogRows([]);
      });
  };

  useEffect(() => {
    if (showLog) {
      onLogRows(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, showLog]);






  return (
    <Modal
      show={showLog}
      onHide={setShowLog}
      size="xl"
      aria-labelledby="edit"
      centered
      className="pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="delete">İnsan resurslarının  barmaq izləri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row bg-white rounded">

          <LogFingerSapTableEmployee
            logRows={logRows}
            chooseSapId={chooseSapId}
            setChooseSapId={setChooseSapId}
            setSortField={setSortField}
            setOrderByTable={setOrderBy}
            sortField={sortField}
            orderBy={orderBy}
            isLoading={isLoading}
            isError={isError}
            updateSkip={setSkip}
            updateTake={setTake}
            take={take}
            setLogId={setLogId}
            logId={logId}
            setShowRemove={setShowRemove}
          />
        </div>
      </Modal.Body>


      {showRemove && (
        <Delete
          id={chooseSapId}
          logId={logId}
          show={showRemove}
          onHide={setShowRemove}
          onLogRows={onLogRows}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}

        />
      )}
    </Modal>
  );
}
